<template>
  <div
    id="main"
    ref="main"
    @mousemove="onMouseMove"
    :class="{'is-full': $route.meta.isFull}"
    class="u-full-width u-relative u-overflow-hidden u-antialiased"
  >
    <symbols-svg />
    <div ref="containerWebGL" class="u-wrapper-panel"/>
    <!-- <router-view v-slot="{ Component }">
      <transition name="t-fader">
        <component :is="Component" />
      </transition>
    </router-view> -->

    <div ref="containerCSS3D" class="u-wrapper-panel u-overflow-hidden"/>
    <img alt="Vue logo" src="./assets/logo.png">
  </div>
</template>

<script>
import { OrbitControls, LoaderManager } from 'shimmer'

import App from './App'

import { webGL } from '@/webGL/WebGL'
import { Environment } from '@/webGL/objects/Environment'
import { CameraAnimation } from '@/webGL/CameraAnimation'

import SymbolsSvg from '@/components/SymbolsSvg'

import {
  AmbientLight,
  SphereBufferGeometry,
  MeshNormalMaterial,
  Mesh
} from 'three'

export default {
  name: 'App',

  mixins: [App],

  components: {
    SymbolsSvg
  },

  created () {
    this.pointerevent = null
  },

  mounted () {
    const ambient = new AmbientLight(0xffffff)
    webGL.scene.add(ambient)

    webGL.camera.position.set(0, 5, 10)

    // this.controls = new OrbitControls(webGL.camera, this.$refs.main)
    // this.controls.enableDamping = true
    // this.controls.dampingFactor = 0.1
    // this.$refs.main.addEventListener('pointerdown', this.controls.onPointerDown)
    // this.$refs.main.addEventListener('pointercancel', this.controls.onPointerCancel)

    this.addEnvironment()

    this.onResize()
  },

  methods: {
    addEnvironment () {
      // this.environment = new Environment('pbr', true)
      this.environment = new Environment('baked')
      webGL.scene.add(this.environment)

      this.environment.promise.then(() => {
        this.cameraAnimation = new CameraAnimation(webGL.camera, this.environment.animationClip)
      })

      setTimeout(() => {
        this.cameraAnimation.active = true
      }, 2000)
    },

    onUpdate (time) {
      if (this.controls) {
        this.controls.update()
      }
      if (this.cameraAnimation) {
        this.cameraAnimation.pointerPosition = this.$device.pointer.smooth
      }
      this._onUpdate(time)
    }
  },

  beforeUnmount () {
    if (this.controls) {
      this.controls.dispose()
    }

    // this.$refs.main.removeEventListener('pointerdown', this.controls.onPointerDown)
    // this.$refs.main.removeEventListener('pointercancel', this.controls.onPointerCancel)
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<style lang="stylus">
// @import '~@/styles/settings/variables'

#main
  min-height 100vh

  &.is-full
    position fixed
    top .2px
    bottom .2px
    left 0
    right 0
    overflow hidden
    min-height auto

</style>